export enum GlobalSearchValueSource {
  LocationVariable = "location_variable",
  RoutingGroup = "routing_group",
  PolicyWorksheet = "policy_worksheet"
}

export enum GlobalSearchScopeKind {
  Org = "org",
  Group = "group",
  Location = "location"
}

// One exact-match hit against operator-authored content.
// Shape is flat (not a union) so it survives tsoa's OpenAPI generation cleanly.
export interface GlobalSearchValueMatchInterface {
  source: GlobalSearchValueSource;
  value: string;
  orgId: number;
  groupId?: number;
  locationId?: number;
  scopeKind: GlobalSearchScopeKind;
  // source === LocationVariable
  locationVarKey?: string;
  // source === RoutingGroup — slug picks Emergency vs Escalation & Ticketing.
  routingGroupSlug?: string;
  routingGroupField?: string;
  // source === PolicyWorksheet
  policyKey?: string;
  policyItemKey?: string;
  // Static definition title/item label — only the server reads policy-definitions JSON.
  policyTitle?: string;
  policyItemLabel?: string;
}
